import { EMPTY_STRING } from '../../../../constants/common'
import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'

export const DEMO_FIELD_NAME = 'message'

export const DEMO_INITIAL_VALUES = {
  [DEMO_FIELD_NAME]: FORMIK_EMPTY_VALUE,
}

export const MOCK_PROMPT_TEXT =
  'Write a friendly reminder about the upcoming building maintenance'

export const MOCK_GENERATED_TEXT = [
  '<p>Dear residents,</p>',
  '<p>This is a friendly reminder that scheduled maintenance in the building will take place tomorrow between 9:00 and 12:00. During this time, the water supply may be temporarily interrupted.</p>',
  '<p>We appreciate your understanding and apologize for any inconvenience this may cause.</p>',
  '<p>Best regards,</p>',
].join(EMPTY_STRING)
